import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-qs-form',
  templateUrl: './qs-form.component.html',
  styleUrls: ['./qs-form.component.scss'],
})
export class QsFormComponent implements OnInit, AfterViewInit {
  bankName: string = '';
  isOnePass: boolean = false;
  deviceType: any;
  otpForm: FormGroup | any;
  transactionForm: FormGroup | any;
  otpWithMobile = true;
  mobile: any;
  orderId: string = '';
  isOtpCalled = false;
  @ViewChild('phoneInput') phoneInput!: ElementRef;

  constructor(
    public form: FormBuilder,
    private apiService: HttpService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    // Get params from URL and store in localStorage
    const urlParams = new URLSearchParams(window.location.search);
    const name = urlParams.get('name') || '';
    const mobileNo = urlParams.get('mobileNo') || '';
    const emailId = urlParams.get('emailId') || '';
    if (name) localStorage.setItem('name', name);
    if (mobileNo) localStorage.setItem('mobileNo', mobileNo);
    if (emailId) localStorage.setItem('emailId', emailId);

    // if this is onepass user
    this.bankName = this.route.snapshot.queryParamMap.get('bankName') ?? '';
    this.mobile = this.route.snapshot.queryParamMap.get('mobile') ?? '';
    this.apiService.setLocalStorage('bName', this.bankName);
    this.isOnePass = localStorage.getItem('bName')?.toLowerCase() === 'onepass';
    if (this.isOnePass) {
      this.apiService.sendOTP(this.getOrderId(), this.mobile).then((res) => {
        if (res > 0) {
          debugger;
          this.toastr.success('Otp sent to your registered mobile number.');
        } else {
          this.toastr.warning('Failed to send otp.');
        }
      });
      this.createTransactionForm();
      // Prefill transactionForm fields if params exist
      setTimeout(() => {
        if (this.transactionForm) {
          // Enable phone field temporarily to allow patchValue
          this.transactionForm.get('phone')?.enable();
          this.transactionForm.patchValue({
            firstname: localStorage.getItem('name') || '',
            phone: localStorage.getItem('mobileNo') || '',
            email: localStorage.getItem('emailId') || '',
          });
          // Re-disable phone field if needed
          this.transactionForm.get('phone')?.disable();
        }
      }, 0);
    } else {
      this.createOtpForm();
      // Prefill otpForm phone if param exists
      setTimeout(() => {
        if (this.otpForm) {
          this.otpForm.patchValue({
            phone: localStorage.getItem('mobileNo') || '',
          });
        }
      }, 0);
    }
    this.deviceType = this.route.snapshot.queryParamMap.get('deviceType');
    this.apiService.setLocalStorage('DeviceType', this.deviceType);
    // this.insertLogs('this.deviceType' + this.deviceType);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const browserValue = this.phoneInput.nativeElement.value;
      if (browserValue && !this.otpForm.get('phone')?.value) {
        this.otpForm.get('phone')?.setValue(browserValue);
        this.otpForm.get('phone')?.updateValueAndValidity();
      }
    });
  }

  createOtpForm() {
    this.otpWithMobile = true;
    this.otpForm = this.form.group({
      phone: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    });
  }

  createTransactionForm() {
    this.otpWithMobile = false;
    this.transactionForm = this.form.group({
      firstname: [
        '',
        [Validators.required, Validators.pattern(/^[A-Za-z\s]+$/)],
      ],
      lastname: [null, [Validators.pattern(/^[A-Za-z\s]+$/)]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ],
      ],
      phone: [
        {
          value: this.isOnePass
            ? this.mobile
            : this.otpForm?.value?.phone || null,
          disabled: true, // Always disabled
        },
        Validators.required,
      ],
      otp: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
      orderId: [this.getOrderId()],
    });
    // Patch values from localStorage immediately after form creation
    const name = localStorage.getItem('name') || '';
    const mobileNo = localStorage.getItem('mobileNo') || '';
    const emailId = localStorage.getItem('emailId') || '';
    if (name || mobileNo || emailId) {
      this.transactionForm.get('phone')?.enable();
      this.transactionForm.patchValue({
        firstname: name,
        phone: mobileNo,
        email: emailId,
      });
      this.transactionForm.get('phone')?.disable();
    }
  }

  getOrderId() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const orderid = urlParams.get('orderId') ?? ''; // Provide a default empty string if null
    this.orderId = orderid;
    // let orderid = '1715775213347152';
    return orderid;
  }

  getPhone() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const phone = urlParams.get('mobile');
    // let orderid = '1715775213347152';
    return phone;
  }

  sendOtp() {
    if (this.otpForm.invalid) return;
    this.isOtpCalled = true;
    this.apiService
      .sendOTP(this.getOrderId(), this.otpForm.value?.phone)
      .then((res) => {
        this.isOtpCalled = false;
        // this.isOtpCalled=false;

        if (res > 0) {
          this.toastr.success(
            'Otp sent to your registered mobile number.',
            '',
            {
              toastClass: 'ngx-toastr custom-toastr',
            }
          );
          const phone = this.otpForm.get('phone')?.value;
          if (phone) localStorage.setItem('mobileNo', phone);
          this.createTransactionForm();
        } else {
          this.toastr.warning('Failed to send otp.');
        }
      })
      .catch((err) => {
        this.isOtpCalled = false;
      });
  }

  saveTransaction() {
    if (this.transactionForm.invalid) return;
    this.isOtpCalled = true;
    this.apiService
      .insertQSInfo({ ...this.transactionForm.getRawValue() })
      .then((response) => {
        this.isOtpCalled = false;

        if (response.status == 'Success') {
          this.apiService.setLocalStorage('Message', response.message);
          this.apiService.setLocalStorage('ChegUrl', response.chegUrl);
          if (response.url.includes('razorpay-checkout')) {
            const name = this.transactionForm.get('firstname')?.value;
            const email = this.transactionForm.get('email')?.value;
            const phone = this.transactionForm.get('phone')?.value;
            if (phone) localStorage.setItem('mobileNo', phone);
            if (email) localStorage.setItem('emailId', email);
            if (name) localStorage.setItem('name', name);
          }
          window.open(response.url, '_self');
        } else if (
          response.status == 'Fail' &&
          response.message == 'Invalid OTP!'
        ) {
          this.toastr.error('Invalid OTP', 'Error');
        } else {
          this.apiService.removeLocalStorage('Message');
          this.apiService.setLocalStorage('Message', response.message);
          this.apiService.setLocalStorage('ChegUrl', response.chegUrl);
          this.router.navigate(['/failure']);
        }
      })
      .catch((err) => {
        this.isOtpCalled = false;
      });
  }

  // ngOnInit(): void {
  //   this.transactionForm = this.form.group({
  //     firstname: ['', Validators.required],
  //     lastname: ['', Validators.required],
  //     email: ['', Validators.required],
  //     phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
  //     orderId: [''],
  //     otp: ['', Validators.pattern(/^\d{6}$/)],
  //   });

  //   this.deviceType = this.route.snapshot.queryParamMap.get('deviceType');
  //   if (this.deviceType == 'web' && this.deviceType != null) {
  //     this.apiService.setLocalStorage('DeviceType', this.deviceType);
  //   }
  //   const bnameOnepass = 'canara';
  //   //  const bnameOnepass = localStorage.getItem('onepass') || '';
  //    this.showFormWithOutOtpScreen = bnameOnepass.toLowerCase() === 'onepass';

  // }

  // validateMaxDigits(control: AbstractControl) {
  //   if (control.value && control.value.length > 10) {
  //     return { maxlength: true };
  //   }
  //   return null;
  // }

  // onSubmission() {
  //   this.transactionForm.get('phone')?.enable();
  //   const phoneNum = this.transactionForm.get('phone')?.value;
  //   // Retrieve the URL query parameters
  //   const queryString = window.location.search;
  //   const urlParams = new URLSearchParams(queryString);
  //   // this.isdisableBtn = true;
  //   // Get the 'orderId' parameter from the URL
  //   // const orderid = urlParams.get('orderId');
  //   let orderid = '1715775213347152';
  //   // Check if the 'orderId' parameter exists
  //   if (orderid) {
  //     // Set the form control's 'orderId' field with the retrieved 'orderId'
  //     this.transactionForm.patchValue({
  //       orderId: orderid,
  //       phone: phoneNum,
  //       // phone:this.transactionForm.get('phone')?.value
  //     });
  //     console.log(this.transactionForm.value);

  //     // Assuming this.apiService is injected as an instance of your service

  //     this.apiService.insertQSInfo(this.transactionForm.value).then((response) => {
  //         console.log('response.chegurl', response.chegUrl);
  //         if (response.status == 'Success') {
  //           window.open(response.url, '_self');
  //         }else if(response.status=='Fail' && response.message=='Invalid OTP!'){
  //           this.toastr.error("Invalid OTP", 'Error')
  //         } else {
  //           this.apiService.removeLocalStorage('Message');
  //           this.apiService.setLocalStorage('Message', response.message);
  //           this.apiService.setLocalStorage('ChegUrl', response.chegUrl);
  //           this.router.navigate(['/failure']);
  //         }
  //         // Handle successful response here

  //         // Add any further logic after a successful submission
  //       })
  //       .catch((error) => {
  //         // Handle error response here
  //         console.error('Failed to submit form:', error);
  //         // Add any error handling logic here
  //       });
  //   }else{
  //     this.toastr.error('Error')
  //     this.transactionForm.get('phone')?.disable();
  //   }
  // }

  // sendOtpData(sendOtp: boolean) {
  //   const queryString = window.location.search;
  //   const urlParams = new URLSearchParams(queryString);
  //   const orderid = urlParams.get('orderId');
  //   const phoneControl = this.transactionForm.get('phone');

  //   //let orderid = '1715775213347152';
  //   const mobile = phoneControl?.value;
  //   const requiredControls = ['firstname', 'lastname', 'otp'];
  //   const requiredPatterns = [
  //     { name: 'phone', pattern: /^\d{10}$/ },
  //     { name: 'email', pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/ },
  //   ];

  //   //const otpControl = this.transactionForm.get('otp');
  //   this.apiService.sendOTP(orderid, mobile).then((res) => {
  //     if (res == 1) {
  //       this.toastr.success(`OTP has been sent to your mobile number`);
  //       this.sendOTP = true;
  //       //this.togglePhoneField();
  //       this.transactionForm.get('phone')?.disable();
  //       if (sendOtp) {
  //         requiredControls.forEach((controlName) => {
  //           const control = this.transactionForm.get(controlName);
  //           if (control) {
  //             control.setValidators(Validators.required);
  //             control.updateValueAndValidity(); // Recalculate the form's validation status
  //           }
  //         });
  //         requiredPatterns.forEach((controlConfig) => {
  //           const control = this.transactionForm.get(controlConfig.name);
  //           if (control) {
  //             control.setValidators([
  //               Validators.required,
  //               Validators.pattern(controlConfig.pattern),
  //             ]);
  //             control.updateValueAndValidity();
  //           }
  //         });
  //       } else {
  //         requiredControls.forEach((controlName) => {
  //           const control = this.transactionForm.get(controlName);
  //           if (control) {
  //             control.clearValidators();
  //             control.updateValueAndValidity(); // Recalculate the form's validation status
  //           }
  //         });
  //       }
  //     } else {
  //       this.transactionForm.get('phone')?.enable();
  //       this.toastr.error('Error');
  //     }
  //   });
  //   // Ensure the form reflects the new validation status
  // }

  goBackTourlpage() {
    window.history.back();
  }
  goBack() {
    // window.history.back();
    this.otpWithMobile = true;
    this.transactionForm.reset();
    //this.transactionForm.get('otp')?.setValue(null);
    this.transactionForm.get('phone')?.enable();
    const requiredControls = ['firstname', 'lastname', 'email', 'otp'];
    requiredControls.forEach((controlName) => {
      const control = this.transactionForm.get(controlName);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity(); // Recalculate the form's validation status
      }
    });
  }
  async insertLogs(url: any) {
    let data = {
      moduleName: 'qs-form',
      url: url,
    };
    let result = this.apiService.insertLogs(data);
  }
}
// togglePhoneField() {
//   if (this.sendOTP) {
//     // Disable the phone field if sendOTP is true
//     this.transactionForm.get('phone')?.disable();
//   } else {
//     // Enable the phone field if sendOTP is false
//     this.transactionForm.get('phone')?.enable();
//   }
// }
